<div class="field field--inline ratio-field">
  <label class="field__label">{{ 'setup.pointsRatioLabel' | transloco }} <span class="field__req">*</span></label>
  <div class="field__input field__input--compact ratio-input" [class.is-invalid]="isInvalid">
    <input inputmode="decimal" [formControl]="control" />
    <span class="field__suffix ratio-coin" [title]="'setup.pointsUnitTitle' | transloco">
      <app-lomy-points [iconOnly]="true"></app-lomy-points>
    </span>
  </div>
</div>
<div class="field__hint ratio-hint" [innerHTML]="'setup.pointsRangeHint' | transloco"></div>
<span class="field__error" *ngIf="showRequired">{{ 'errors.required' | transloco }}</span>
<span class="field__error" *ngIf="showPattern">{{ 'errors.numbersOnly' | transloco }}</span>
<span class="field__error" *ngIf="showMin">{{ 'errors.min0001' | transloco }}</span>
<span class="field__error" *ngIf="showMax">{{ 'errors.max100' | transloco }}</span>

<!-- Live calculator: customer-visible points vs precise accumulation -->
<div class="ratio-calc">
  <div class="ratio-calc__row">
    <span>{{ 'setup.calcExampleLabel' | transloco }}</span>
    <div class="field__input field__input--compact ratio-calc__amount">
      <span class="field__prefix">€</span>
      <input inputmode="decimal" [(ngModel)]="sampleAmount" [ngModelOptions]="{ standalone: true }" />
    </div>
  </div>
  <div class="ratio-calc__values">
    <div class="ratio-calc__value">
      <div class="ratio-calc__value-label">{{ 'setup.calcAwardedLabel' | transloco }}</div>
      <div class="ratio-calc__value-num ratio-calc__value-num--awarded">
        <span>{{ awardedPoints }}</span>
        <span class="ratio-coin" [title]="'setup.pointsUnitTitle' | transloco">
          <app-lomy-points [iconOnly]="true"></app-lomy-points>
        </span>
      </div>
    </div>
    <div class="ratio-calc__value">
      <div class="ratio-calc__value-label">{{ 'setup.calcAccumulatedLabel' | transloco }}</div>
      <div class="ratio-calc__value-num ratio-calc__value-num--accumulated">
        <span>{{ accumulatedPoints }}</span>
        <span class="ratio-coin" [title]="'setup.pointsUnitTitle' | transloco">
          <app-lomy-points [iconOnly]="true"></app-lomy-points>
        </span>
      </div>
    </div>
  </div>
</div>
<div class="field__hint ratio-calc-hint" [innerHTML]="'setup.calcExplanation' | transloco"></div>
